import Qs from 'qs';
import { IActions } from './IActions';
import { AxiosInstance, CancelToken } from 'axios';
import { State } from './State';
import { Config } from './Config';
import { Filter } from './Filter';
import { IPagedResult } from './IPagedResult';

export class EfApiActions implements IActions {
  private axios: AxiosInstance;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private key: (entity: any) => string | number;
  private baseUrl: string;

  constructor(
    axios: AxiosInstance,
    apiRoute: string,
    entityName: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    key: (entity: any) => string | number
  ) {
    this.axios = axios;
    this.baseUrl = apiRoute + entityName;
    this.key = key;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  public add = (entity: any) =>
    this.axios.post(this.baseUrl, entity).then((response) => response.data);

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  public update = (entity: any) =>
    this.axios.put(`${this.baseUrl}/${this.key(entity)}`, entity).then((response) => response.data);

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  public delete = (entity: any) =>
    this.axios
      .delete(`${this.baseUrl}/${this.key(entity)}`, { data: entity })
      .then((response) => response.data);

  public stateChanged = (
    skip: number,
    take: number,
    state: State,
    config: Config,
    search: string,
    cancelToken: CancelToken
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<IPagedResult<any>> => {
    const mapToFilter = (filter: Filter): string => {
      if (filter.fieldType === 'boolean') {
        let filterValue = filter.filterQuery.join('||');
        if (filterValue.indexOf('true') >= 0) {
          filterValue = '1';
        } else if (filterValue.indexOf('false') >= 0) {
          filterValue = '0';
        }
        return `${filter.fieldName}=${filterValue}`;
      } else {
        return `${filter.fieldName}=${filter.filterQuery.join('||')}`;
      }
    };
    const allFilters = config.permanentFilters.concat(state.filters);
    const contains = allFilters
      .filter((f) => f.filterType === 'contains')
      .map((filter) => `${filter.fieldName}=${filter.filterQuery.join('||')}`);
    const equals = allFilters.filter((f) => f.filterType === 'equals').map(mapToFilter);
    const notequals = allFilters.filter((f) => f.filterType === 'notequals').map(mapToFilter);
    const before = allFilters
      .filter((f) => f.filterType === 'before')
      .map((filter) => `${filter.fieldName}=${filter.filterQuery.join('||')}`);
    const after = allFilters
      .filter((f) => f.filterType === 'after')
      .map((filter) => `${filter.fieldName}=${filter.filterQuery.join('||')}`);
    const between = allFilters
      .filter((f) => f.filterType === 'between')
      .map((filter) => `${filter.fieldName}=${filter.filterQuery.join('||')}`);

    return this.axios
      .get(this.baseUrl, {
        params: {
          skip: skip,
          take: take,
          orderBy: state.sorting.map((s) => `${s.sortBy}=${s.sortMode === 'descending'}`),
          contains: contains,
          equals: equals,
          notequals: notequals,
          before: before,
          after: after,
          between: between,
          search: search
        },
        paramsSerializer: function (params) {
          return Qs.stringify(params, { arrayFormat: 'repeat' });
        },
        cancelToken: cancelToken
      })
      .then((response) => (response ? response.data : undefined))
      .catch((error: Error) => {
        // @ts-ignore
        if (error.__CANCEL__ === false) {
          throw error;
        }
      });
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public load = this.stateChanged;
}
